import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { GlobalState } from './types';
import { RootState } from '@/store/types';

const namespaced = true;

export const state: GlobalState = {
  cartOpen: false,
  globalLoading: false,
  cart: null,
  checkout: null,
  paypalData: null,
  showHeader: true,
};

export const globalState: Module<GlobalState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};